import { useState } from "react";
import API, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Field } from "./PortalPage";
import { fmtMoney } from "./portalUtils";
import { toast } from "sonner";

export const PAY_METHODS = ["BACS / Bank Transfer", "Faster Payment", "CHAPS", "Card", "Cheque", "Cash", "Other"];

/* "I've paid" dialog shared by the invoice list and the in-portal invoice view. `invoice` null → closed. */
export function MarkPaidDialog({ invoice, onClose, onDone }) {
  const [form, setForm] = useState({ method: "", reference: "", notes: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await API.post(`/client-hub/invoices/${invoice.id}/mark-paid`, form);
      toast.success(data.message);
      setForm({ method: "", reference: "", notes: "" });
      onDone?.();
      onClose();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!invoice} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="mark-paid-dialog">
        <DialogHeader><DialogTitle>Confirm payment — {invoice?.reference || invoice?.invoice_number}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{fmtMoney(invoice?.amount)} · Our team will verify receipt and update the invoice.</p>
        <div className="space-y-3">
          <Field label="Payment method">
            <Select value={form.method} onValueChange={(v) => setForm({ ...form, method: v })}>
              <SelectTrigger data-testid="paid-method"><SelectValue placeholder="Select…" /></SelectTrigger>
              <SelectContent>{PAY_METHODS.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
          <Field label="Payment reference"><Input value={form.reference} onChange={(e) => setForm({ ...form, reference: e.target.value })} data-testid="paid-reference" /></Field>
          <Field label="Notes"><Textarea rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} data-testid="paid-notes" /></Field>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={busy} data-testid="paid-confirm">Confirm</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
